module.exports = __webpack_public_path__ + "img/w3_circle_reload_white.4ba45a7e.png";